import { createActions } from 'redux-actions';
import { addFlashMessage, clearMessage } from '../Flash';
import api from '../../../api';
import { getErrorMessages } from '../../../shared/helpers';

export const { sendPayment } = createActions({});

export const sendPaymentToken = params => dispatch => {
  dispatch(clearMessage());
  return api
    .sendPaymentToken(params)
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }

      return dispatch(addFlashMessage('Success message', 'success'));
    })
    .catch(e => {
      const errors = getErrorMessages(e);
      return dispatch(addFlashMessage(errors, 'error'));
    });
};



// WEBPACK FOOTER //
// ./src/store/actions/Payment/index.js